import { FC, ReactNode } from 'react';

import { Root } from './PageLayout.ui';

type PageLayoutProps = {
  children: ReactNode;
};

export const PageLayout: FC<PageLayoutProps> = (props) => {
  const { children } = props;

  return <Root>{children}</Root>;
};
